import { ref, computed } from 'vue'
import { overlayConfigs } from '@/config/overlays'

export function useOverlays() {
  const currentIndex = ref(0)
  const imageCache = new Map()
  const overlayImage = ref(null)
  const transitioning = ref(false)

  const currentOverlay = computed(() => overlayConfigs[currentIndex.value])

  function loadImage(src) {
    return new Promise((resolve, reject) => {
      if (imageCache.has(src)) {
        resolve(imageCache.get(src))
        return
      }
      const img = new Image()
      img.onload = () => {
        imageCache.set(src, img)
        resolve(img)
      }
      img.onerror = () => reject(new Error(`Failed to load overlay: ${src}`))
      img.src = src
    })
  }

  async function preloadAll() {
    const promises = overlayConfigs.map(config => loadImage(config.src))
    await Promise.allSettled(promises)
    if (overlayConfigs.length > 0) {
      overlayImage.value = imageCache.get(overlayConfigs[0].src) || null
    }
  }

  async function switchOverlay(index) {
    if (overlayConfigs.length === 0) return
    transitioning.value = true
    currentIndex.value = index
    try {
      overlayImage.value = await loadImage(overlayConfigs[index].src)
    } catch (err) {
      console.error(err)
    }
    setTimeout(() => {
      transitioning.value = false
    }, 150)
  }

  function nextOverlay() {
    if (overlayConfigs.length <= 1) return
    const next = (currentIndex.value + 1) % overlayConfigs.length
    switchOverlay(next)
  }

  function prevOverlay() {
    if (overlayConfigs.length <= 1) return
    const prev = (currentIndex.value - 1 + overlayConfigs.length) % overlayConfigs.length
    switchOverlay(prev)
  }

  return {
    currentIndex,
    currentOverlay,
    overlayImage,
    transitioning,
    preloadAll,
    nextOverlay,
    prevOverlay
  }
}
